import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type LabelPillElement } from '../../types/aha-editor';
import { type Descendant } from 'slate';
import { isLabelPillElement } from '../../types/guards';
import {
  isLabelPillNode,
  LABEL_DEPRECATED_PILL_CLASS_PREFIX,
  LABEL_V1_PILL_CLASS,
  LABEL_V1_PILL_CLASS_PREFIX,
  sanitizeLabelPillColor,
} from '../../plugins/LabelPillPlugin/utils';

class SerializerLabelPill extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments): LabelPillElement | Descendant[] | undefined {
    if (!isLabelPillNode(el)) return;

    // TODO: This was removed before v2 launch, we can remove it some amount of time after GA.
    const deprecatedColorClassName = Array.from(el.classList).find(
      (className) => className.startsWith(LABEL_DEPRECATED_PILL_CLASS_PREFIX)
    );
    const v1ColorClassName = Array.from(el.classList).find((className) =>
      className.startsWith(LABEL_V1_PILL_CLASS_PREFIX)
    );
    const colorClassName = v1ColorClassName || deprecatedColorClassName;
    if (!colorClassName) {
      return;
    }

    const colorScheme = sanitizeLabelPillColor(
      colorClassName
        .replace(LABEL_V1_PILL_CLASS_PREFIX, '')
        .replace(LABEL_DEPRECATED_PILL_CLASS_PREFIX, '')
    );

    return {
      type: 'pill',
      pill_colorScheme: colorScheme,
      children: next(el.childNodes, markAttributes),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isLabelPillElement(node)) return;

    const colorScheme = sanitizeLabelPillColor(node.pill_colorScheme);
    return (
      <span
        className={`${LABEL_V1_PILL_CLASS} ${LABEL_V1_PILL_CLASS_PREFIX}${colorScheme}`}
      >
        {children}
      </span>
    );
  }
}

export default SerializerLabelPill;
